import {
  BillsAndBalancesResponse,
  MadingResponse,
  ReportBalancesResponse,
  SlidersResponse,
} from "./dtos/home.dto";
import { BaseService } from "./base.service";
import { BaseResponseExternal } from "./dtos/base.dto";

interface HomeServiceInterface {
  queries: {
    GET_BILLS_AND_BALANCES: string;
    GET_DATA_REPORT_BALANCES: string;
    GET_MADING: string;
    GET_SLIDER: string;
  };
  billsAndBalances(payload: { nis: string }): Promise<BillsAndBalancesResponse>;
  reportBalances(payload: {
    nis: string;
    limit: string;
  }): Promise<ReportBalancesResponse>;
  mading(kategori: string, limit: string): Promise<MadingResponse>;
  sliders(): Promise<SlidersResponse>;
}

export const HomeService: HomeServiceInterface = {
  queries: {
    GET_BILLS_AND_BALANCES: "GET_BILLS_AND_BALANCES",
    GET_DATA_REPORT_BALANCES: "GET_DATA_REPORT_BALANCES",
    GET_MADING: "GET_MADING",
    GET_SLIDER: "GET_SLIDER",
  },

  billsAndBalances: async (payload: { nis: string }) => {
    try {
      const request = await BaseService.ci4Request().get<BillsAndBalancesResponse>(
        "/tagihan/bill-and-balance",
        { params: payload },
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  reportBalances: async (payload: { nis: string; limit: string }) => {
    try {
      const request = await BaseService.ci4Request().get<ReportBalancesResponse>(
        "/keuangan/laporan-uang-saku",
        { params: payload },
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  mading: async (kategori: string, limit: string) => {
    try {
      const request = await BaseService.ci4Request().get<BaseResponseExternal>(
        `/admin/mading-slider/${kategori}/${limit}`,
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      throw new Error(error.message);
    }
  },

  sliders: async () => {
    try {
      const request =
        await BaseService.request().get<SlidersResponse>("/home/sliders");
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
};
